import { AbstractControl, ValidationErrors } from '@angular/forms';

export const duplicatesValidator = (control: AbstractControl<string[]>): ValidationErrors | null => {
  const values = control.value;

  if (!Array.isArray(values) || values.length === 0) {
    return null;
  }

  return new Set(values).size !== values.length ? { duplicates: 'validation.duplicates' } : null;
};
